import React, { useContext } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store"; // Import the Redux store
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}> {/* Provide the Redux store */}
      <BrowserRouter> {/* Ensure BrowserRouter is included */}
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
